import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hideBottomBorder", "rootBreadcrumbs"];
import { PureComponent } from 'react';
import OccurrenceLabel from 'ContentComponents/components/cmv2/occurrences/OccurrenceLabel';
import { getFieldFromKey, shouldOmitFieldFromBreadcrumbs } from 'ContentComponents/components/cmv2/utils';
import { getDeepValue } from 'ContentUtils/helpers/ObjectHelpers';
import { View } from 'foundations-components/components/View';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Link } from 'foundations-components/transitional/components/Link';
import { filterProps } from 'foundations-components/utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class EditFormBreadcrumbs extends PureComponent {
  renderBreadCrumbs() {
    const {
      fieldKey,
      fields,
      module,
      onKeyChange
    } = this.props;
    if (!fieldKey || !fields) {
      return null;
    }
    return fieldKey.reduce((acc, keyName, index) => {
      const _key = fieldKey.slice(0, index + 1);
      const _field = getFieldFromKey(fields, _key) || {};
      const isDisabled = !fieldKey || index === fieldKey.length - 1;
      if (shouldOmitFieldFromBreadcrumbs(_field)) return acc;
      if (_field && typeof keyName === 'number') {
        const _value = getDeepValue(module, _key);
        acc.push( /*#__PURE__*/_jsx(Link, {
          disabled: isDisabled,
          onClick: () => onKeyChange(_key),
          children: /*#__PURE__*/_jsx(OccurrenceLabel, {
            asString: true,
            defaultLabel: _field.label || `${_value}`,
            field: _field,
            value: _value
          })
        }, _key.join('')));
      } else if (_field && !_field.occurrence) {
        acc.push( /*#__PURE__*/_jsx(Link, {
          disabled: isDisabled,
          onClick: () => onKeyChange(_key),
          children: _field.label
        }, _key.join('')));
      }
      return acc;
    }, []);
  }
  render() {
    const _this$props = this.props,
      {
        hideBottomBorder,
        rootBreadcrumbs
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      tokenProps
    } = filterProps(rest);
    return /*#__PURE__*/_jsx(View, Object.assign({
      borderBlockEndColor: "border-core-default",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: hideBottomBorder ? '0' : '100',
      paddingInline: "500",
      paddingBlock: "200"
    }, tokenProps, {
      children: /*#__PURE__*/_jsxs(Breadcrumbs, {
        padding: "0",
        margin: "0",
        truncateToLevels: 2,
        singleBreadcrumbIsBackLink: false,
        children: [rootBreadcrumbs && rootBreadcrumbs, this.renderBreadCrumbs()]
      })
    }));
  }
}
export default EditFormBreadcrumbs;